import React from 'react';
import { Grid } from '@mui/material';
import GroupedPageLines from '../@common/GroupedPageLines';
import { LargePageLineText } from '../@common/PageLineText';
import { translate } from '../../translations/translator';
const t = key => translate('worksheet', key);

const ReasonRow = ({
  fontSize,
  fontFamily,
  marginTop,
  marginTopLine = 0,
  reasons = false,
  noText = false,
  lineWidth = 685,
  number
}) => {
  if (!reasons) {
    return (
      <GroupedPageLines
        top={8}
        width={1000}
        fontSize={fontSize}
        color="black"
        marginLeftText={3}
        marginTopText={marginTop}
        marginPageLines="8px 25px 0px"
        fontFamily={fontFamily}
        isWide
        paddingTop={30}
      >
        {t('myReason')}:
      </GroupedPageLines>
    );
  }
  return (
    <Grid container spacing={1} style={{ marginTop: marginTopLine }}>
      <Grid container item spacing={3}>
        {!noText && (
          <Grid item xs={3}>
            <GroupedPageLines
              top={8}
              width={250}
              fontSize={fontSize}
              color="black"
              marginLeftText={3}
              marginTopText={'-34px'}
              marginPageLines="10px 25px 0px"
              fontFamily={fontFamily}
              isWide
              paddingTop={30}
            >
              {t('reasons')}:
            </GroupedPageLines>
          </Grid>
        )}

        <Grid item xs={1} style={{ marginTop: noText ? 20 : 18, marginLeft: noText ? 50 : 70 }}>
          <LargePageLineText>
            <div style={{ marginLeft: '-40px' }}>{number}.</div>
          </LargePageLineText>
        </Grid>
        <Grid item xs={8} style={{ marginTop: 8, marginLeft: -115 }}>
          <GroupedPageLines marginTopText={'0 px'} width={lineWidth} isWide paddingTop={30} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ReasonRow;
